/**
 * 로그인 없이 직접 진입하는 화면 판정.
 *
 * CMS 에서 회원 정보를 보다가 URL 로 넘어오는 케이스(웹 전용)라 세션이 없다.
 * 이 상태에서는 API 가 401/403 을 줄 수 있는데, 전역 인터셉터의 로그아웃 처리를
 * 그대로 타면 로그인 화면으로 튕기므로 App.js 와 CommonApi.js 가 이 판정을 공유한다.
 */

/** 비로그인 직접 진입을 허용하는 경로 */
export const DIRECT_ENTRY_PATHS = ["/mypage/myExamInfo", "/mypage/myExamScore"];

/** MMBR_SEQ 를 달고 위 경로로 들어온 경우에만 직접 진입으로 본다. */
export const isDirectEntry = (pathname, search) =>
    DIRECT_ENTRY_PATHS.includes(pathname) && new URLSearchParams(search).has("MMBR_SEQ");

/** 리액트 라우터 밖(인터셉터 등)에서 쓰는 현재 URL 기준 판정 */
export const isDirectEntryUrl = () => isDirectEntry(window.location.pathname, window.location.search);
